import { style, fontFace } from 'typestyle';

import metropolisFontURL from '../../public/fonts/Metropolis-Bold.woff2';
import sfFontURL from '../../public/fonts/sf-pro-text-regular.woff';

fontFace({
  fontFamily: 'Metropolis',
  src: `url(${metropolisFontURL}) format("woff2")`,
});

fontFace({
  fontFamily: 'SF Pro',
  src: `url(${sfFontURL}) format("woff")`,
});

const sharedFontStyles = {
  fontStyle: 'normal',
};

export const FontSizeRaw = {
  xSmall: {
    fontSize: `${12 / 16}rem`,
  },
  Small: {
    fontSize: `${14 / 16}rem`,
  },
  Normal: {
    fontSize: '1rem',
  },
  Large: {
    fontSize: `${18 / 16}rem`,
  },
  xLarge: {
    fontSize: `${20 / 16}rem`,
  },
  xxLarge: {
    fontSize: `${24 / 16}rem`,
  },
};

export const FontsRaw = {
  HeadingDefault: {
    ...sharedFontStyles,
    fontWeight: '600',
    fontSize: FontSizeRaw.Large.fontSize,
    fontFamily: 'SF Pro',
    fontStyle: 'normal',
  },

  HeadingXS: {
    ...sharedFontStyles,
    fontSize: '24px',
    fontFamily: 'Metropolis',
  },

  BodyDefault: {
    ...sharedFontStyles,
    fontWeight: '400',
    fontSize: FontSizeRaw.Normal.fontSize,
    fontFamily: 'SF Pro',
  },
};

const headingDefault = style(FontsRaw.HeadingDefault);
const headingXS = style(FontsRaw.HeadingXS);
const bodyDefault = style(FontsRaw.BodyDefault);

export const Fonts = {
  HeadingDefault: headingDefault,
  HeadingXS: headingXS,
  BodyDefault: bodyDefault,
};

export const FontSize = {
  xSmall: style(FontSizeRaw.xSmall),
  Small: style(FontSizeRaw.Small),
  Normal: style(FontSizeRaw.Normal),
  Large: style(FontSizeRaw.Large),
  xLarge: style(FontSizeRaw.xLarge),
  xxLarge: style(FontSizeRaw.xxLarge),
};
